/**
 * @generated SignedSource<<fb07148d7fe760098c5d2ed35c7d68d9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EnvironmentEnum = "LOCAL" | "INHOUSE_MASTER" | "INHOUSE_OMEGA1" | "INHOUSE_OMEGA2" | "INHOUSE_OMEGA3" | "INHOUSE_QA" | "INHOUSE_STAGING" | "PRODUCTION_MASTER" | "%future added value";
export type RequestCaregiverPasswordResetInput = {
  email: string;
  environment: EnvironmentEnum;
  clientMutationId?: string | null;
};
export type RequestPasswordResetFormMutation$variables = {
  input: RequestCaregiverPasswordResetInput;
};
export type RequestPasswordResetFormMutation$data = {
  readonly requestCaregiverPasswordReset: {
    readonly status: string;
  } | null;
};
export type RequestPasswordResetFormMutation = {
  variables: RequestPasswordResetFormMutation$variables;
  response: RequestPasswordResetFormMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RequestCaregiverPasswordResetPayload",
    "kind": "LinkedField",
    "name": "requestCaregiverPasswordReset",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RequestPasswordResetFormMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RequestPasswordResetFormMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "75ce2669163ec9589e44239572fdca50",
    "id": null,
    "metadata": {},
    "name": "RequestPasswordResetFormMutation",
    "operationKind": "mutation",
    "text": "mutation RequestPasswordResetFormMutation(\n  $input: RequestCaregiverPasswordResetInput!\n) {\n  requestCaregiverPasswordReset(input: $input) {\n    status\n  }\n}\n"
  }
};
})();

(node as any).hash = "3a49c84a3598f9f9d43b1b9289b5479c";

export default node;
